<template>
  <div>
    <Mainlayout></Mainlayout>
    <!-- badan page -->
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center mt-5 m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin mt-5">
            <br />

            <CCard class="p-2 bg-gradient-turqouise">
              <CCol sm="12">
                <CRow>
                  <CCol sm="2">
                    <div class="text-right">
                      <img
                        v-if="teacherProfile.filepath == null"
                        style="border: 1px solid #eee"
                        src="../../assets/img/default.png"
                        class="grey lighten-2 rounded-img img-profile mt-2"
                      />

                      <img
                        v-else
                        style="border: 3px solid #ddd; background: #fff"
                        :src="photoURL"
                        class="grey lighten-2 rounded-img img-profile mt-2"
                      />
                    </div>
                  </CCol>
                  <CCol sm="6"
                    ><p class="text-left mt-3 text-white">
                      Hi
                      <strong class="text-uppercase">
                        <i>{{ teacherProfile.userName }} </i> </strong
                      >.Welcome to Pickiddo Web Application ! <br />
                      To get started, you can browse your profile and quiz
                      section.
                    </p>
                  </CCol>
                  <CCol sm="3"></CCol>
                </CRow>
              </CCol>
            </CCard>
            <hr />

            <CCol sm="12">
             <h5 class="mb-3">All services provided by Pickiddo</h5>
              <CRow>
                <CCol sm="3" lg="3">
                  <CCard accent-color="primary" @click="GoToTeacherProfile()">
                    <CCardBody @click="GoToTeacherProfile()">
                      <div class="text-center">
                        <img
                          class="text-center m-0"
                          style="width: 100px"
                          src="../../assets/img/profileicon500x500green.png"
                        />
                        <br /><label class="text-center">Profile</label>
                      </div></CCardBody
                    >
                  </CCard>
                </CCol>
                <CCol sm="3" lg="3">
                  <CCard accent-color="primary" @click="GoToDashBoard()">
                    <CCardBody @click="GoToDashBoard()"
                      ><div class="text-center">
                        <img
                          class="text-center m-0"
                          style="width: 100px"
                          src="../../assets/img/quizicon500x500line.png"
                        /><br /><label class="text-center">Quiz</label>
                      </div></CCardBody
                    >
                  </CCard>
                </CCol>
                <CCol sm="3" lg="3"> </CCol>
                <CCol sm="3" lg="3"> </CCol>
              </CRow>
            </CCol>
            <hr />
            <CCol am="12">
              <h5 class="mb-3">What News</h5>
              <CRow>
                <CCol
                  v-for="(item, index) in news.slice(0, 4)"
                  v-bind:key="item.Id"
                  sm="3"
                >
                  <a :href="GoToLink(index)">
                    <img
                      style="max-width: 200px; border-radius: 20px"
                      :src="getPic(index)"
                    />
                  </a>
                </CCol>
              </CRow>
            </CCol>
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import backgroundBanner from "../../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../../containers/TheHeaderWoMenu.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      teacherProfile: {},
      news: [],
    };
  },
  async mounted() {
    this.GetUserProfile();
    this.GetNews();
  },
  computed: {},
  methods: {
    async GetUserProfile() {
      this.$API
        .get(this.$TeacherProfile + "?userId=" + this.$route.query.userId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherProfile = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.teacherProfile.filepath;
            $("#profileImage").text(this.photoURL);
          }
        });
    },
    GoToDashBoard() {
      this.$router.push(
        "../../QuizTeacherDashboard?userId=" + this.$route.query.userId
      );
    },
    GoToTeacherProfile() {
      this.$router.push(
        "../../QuizTeacherProfile?userId=" + this.$route.query.userId
      );
    },
    async GetNews() {
      this.$API
        .get(this.$News, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.news = response.data;
            this.getPic(this.news.urlImage);
            this.GoToLink(this.news.Url);
          }
        });
    },
    getPic(index) {
      return this.news[index].urlImage;
    },

    GoToLink(index) {
      return this.news[index].Url;
    },
  },
};
</script>
<style>
#fb-root {
  display: none;
}
</style>
  